<template>
    <client-page class="app--main">
        <!-- S: sub-visual -->
        <section class="sub-visual">
            <v-container>
                <div class="tit-wrap mb-24 mb-md-50 mb-lg-0">
                    <v-img class="tit-wrap__img" src="/images/common/tit-img.png"></v-img>
                    <h2 class="tit tit--xl">
                        Business
                    </h2>
                </div>
            </v-container>
            <v-img class="sub-visual__img" src="/images/sub/business/sub-visual-business.jpg"></v-img>
            <sub-tab page="비즈니스" :tabActive="1"></sub-tab>
        </section>
        <!-- E: sub-visual -->

        <!-- S: overview -->
        <section class="sub-section sub-section--overview pb-0">
            <v-container>
                <div class="tit-wrap tit-wrap--center" data-aos="fade-up">
                    <h3 class="tit tit--lg mb-12">
                        ONE STOP SHOPPING
                    </h3>
                    <p class="page-text page-text--lg font-weight-medium">
                        소상 공인부터 프랜차이즈 그리고 대기업 사장님들까지 다양한 수효를 아우르는 모두 에프엔티의 서비스
                    </p>
                </div>
                <v-card flat class="business-info white--text" data-aos="fade-up" data-aos-delay="100">
                    <div class="px-20 py-50 py-md-74 pa-lg-100">
                        <v-row>
                            <v-col cols="12" md="6">
                                <div class="h-100 d-flex flex-wrap align-content-space-between">
                                    <div class="w-100 mb-12 mb-md-0">
                                        <v-img src="/images/sub/business/overview/logo.png" max-width="80"></v-img>
                                    </div>
                                    <div>
                                        <div class="tit-wrap tit-wrap--xs">
                                            <h3 class="tit font-pretendard">
                                                (주) 모두에프엔티
                                            </h3>
                                        </div>
                                        <p class="page-text page-text font-weight-medium">
                                            여러가지 식자재 재료가 한번에 필요하고 물류가 고민일때 <br class="d-none d-lg-block" />
                                            모두 에프엔티가 유통에 도움을 드립니다.
                                        </p>
                                    </div>
                                </div>
                            </v-col>

                            <v-col cols="12" md="6" class="line-height-11">
                                <v-row>
                                    <v-col cols="12">
                                        <p class="page-text">
                                            <span class="d-block d-md-inline-block w-md-80px w-lg-120px font-weight-medium primary--text mb-6 mb-md-0">연매출</span>
                                            89억 5000만원
                                        </p>
                                    </v-col>

                                    <v-col cols="12">
                                        <p class="page-text">
                                            <span class="d-block d-md-inline-block w-md-80px w-lg-120px font-weight-medium primary--text mb-6 mb-md-0">자본금</span>
                                            1억 5000만원
                                        </p>
                                    </v-col>

                                    <v-col cols="12">
                                        <p class="page-text">
                                            <span class="d-block d-md-inline-block w-md-80px w-lg-120px font-weight-medium primary--text mb-6 mb-md-0">업종</span>
                                            식자재,유통,도소매업,음식료품 취급
                                        </p>
                                    </v-col>

                                    <v-col cols="12">
                                        <p class="page-text">
                                            <span class="d-block d-md-inline-block w-md-80px w-lg-120px font-weight-medium primary--text mb-6 mb-md-0">주소</span>
                                            경기도 하남시 창우로 38-35번지
                                        </p>
                                    </v-col>

                                    <v-col cols="12">
                                        <p class="page-text">
                                            <span class="d-block d-md-inline-block w-md-80px w-lg-120px font-weight-medium primary--text mb-6 mb-md-0">직원수</span>
                                            18명
                                        </p>
                                    </v-col>

                                    <v-col cols="12">
                                        <p class="page-text">
                                            <span class="d-block d-md-inline-block w-md-80px w-lg-120px font-weight-medium primary--text mb-6 mb-md-0">사업자 번호</span>
                                            126-81-93789
                                        </p>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </div>
                </v-card>

                <!-- S: 조직도 -->
                <div class="my-80 my-md-120 my-lg-160">
                    <div class="tit-wrap tit-wrap--center">
                        <h3 class="tit tit--lg" data-aos="fade-up">조직도</h3>
                    </div>
                    <v-img class="d-md-none" src="/images/sub/business/overview/organization-mobile.jpg" data-aos="fade-up" data-aos-delay="100"></v-img>
                    <v-img class="d-none d-md-block" src="/images/sub/business/overview/organization.png" data-aos="fade-up" data-aos-delay="100"></v-img>
                </div>
                <!-- E: 조직도 -->
            </v-container>

            <!-- S: ci -->
            <div class="ci">
                <v-container>
                    <div class="tit-wrap tit-wrap--center white--text" data-aos="fade-up">
                        <h3 class="tit tit--lg">CI</h3>
                    </div>
                    <v-img class="d-md-none" src="/images/sub/business/overview/ci-mobile.png" data-aos="fade-up" data-aos-delay="100"></v-img>
                    <v-img class="d-none d-md-block" src="/images/sub/business/overview/ci.png" data-aos="fade-up" data-aos-delay="100"></v-img>
                    <div class="pt-30 pt-md-44 pt-lg-60" align="center">
                        <v-row class="row--x-small" justify="center">
                            <v-col cols="auto">
                                <v-btn large class="w-140px w-md-160px" href="/assets/logo/logo.ai">AI 다운로드</v-btn>
                            </v-col>
                            <v-col cols="auto">
                                <v-btn large class="w-140px w-md-160px" href="/assets/logo/logo.png" target="_blank">PNG 다운로드</v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </v-container>
            </div>
            <!-- E: ci -->
        </section>
        <!-- E: overview -->
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubTab from "@/components/client/sub/sub-tab.vue";
// import BoardList from "@/components/client/board/board-list.vue";
import PopupLayer from "@/components/client/popup/popup-layer.vue";
import LocaleSelect from "@/components/client/inc/locale-select.vue";
import { BOARD_YOUTUBE_CATEGORIES, BOARD_REPORT_CATEGORIES, BOARD_FORMS_CATEGORIES } from "@/assets/variables";
import Swiper from "swiper/bundle";
import IconArrowRounded from "@/components/client/icons/icon-arrow-rounded.vue";

const categoriesYoutube = Object.values(BOARD_YOUTUBE_CATEGORIES);
const categoriesReport = Object.values(BOARD_REPORT_CATEGORIES);
const categoriesForms = Object.values(BOARD_FORMS_CATEGORIES);

export default {
    components: {
        ClientPage,
        SubTab,
        // BoardList,
        PopupLayer,
        LocaleSelect,
        IconArrowRounded,
    },
    props: {
        isMain: { type: Boolean, default: true },
    },
    data: () => ({
        categoriesYoutube,
        categoriesReport,
        categoriesForms,
    }),
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {
                this.Swiper = new Swiper(".products-slide .swiper-container", {
                    slidesPerView: 1,
                    spaceBetween: 120,
                    speed: 1000,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    breakpoints: {
                        // pc
                        768: {
                            slidesPerView: 2,
                        },
                    },
                });
            });
        },
    },
};
</script>
